




























































import {Vue, Component} from 'vue-property-decorator'
import getConnection from "@/utils/signalr_connection";

@Component({})
export default class Activities extends Vue {
  events = [];
  async created() {
    getConnection().on('newEventHappened', this.loadEvents);
    await this.loadEvents();
  }

  async loadEvents() {
    const { data } = await this.$http.get('/api/GetRecentEvents');
    this.events = data;
  }
}
